export const REAL_TIME_PRICING = {
    REAL_TIME_PRICING: "pricing",
    EXTERNAL_URI_INPUT: "RTP_external_url",
    TIMEOUT: "RTP_timeout",
    SKUS_PER_CALL: "RTP_skus_per_call",
    CLOUD_FUNCTION_URI: "RTP_cloud_function_url",

    SPLIT_CART_TOGGLE: "RTP_split_toggle",

    SAVE_BUTTON: "RTP_save_button",
    ADD_SECRET_BUTTON: "RTP_add_secret_button",
    NEW_SECRET_FIELD: "RTP_new_secret_field",
    DELETE_SECRET_BUTTON: "RTP_delete_secret_button",
    NEW_SECRET_KEY_FIELD: "RTP_new_secret_key_field",
};
